import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";
import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

async function getTeam() {
  const data = await axiosInstance({
    url: "/team",
    method: "GET",
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function createTeam(formData) {
  const data = await axiosInstance({
    url: "/team",
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function updateTeam(formData) {
  const data = await axiosInstance({
    url: `/team/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function deleteTeam(formData) {
  const data = await axiosInstance({
    url: `/team/${formData}`,
    method: "DELETE",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useTeam() {
  const fallback = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.team],
    queryFn: getTeam,
  });
  return data;
}

export function useUpdateTeam() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => updateTeam(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.team]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}

export function useAddTeam() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => createTeam(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.team]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
export function useDeleteTeam() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => deleteTeam(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.team]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
